<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a=>a.show || a.active)"
              :items="items"
              :footer-props="datatable_footer"
              :server-items-length="total"
              :options.sync="table_options"
              :loading="loading"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        sm="2"
                      >
                        <v-text-field
                          v-model="form.search"
                          clearable
                          outlined
                          label="Поиск"
                          prepend-inner-icon="mdi-magnify"
                          dense
                          @keyup.enter="onLoad"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onShowFilterDialog"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        class="d-sm-flex justify-end"
                        md="2"
                        offset-md="2"
                        offset-xl="4"
                        xl="1"
                      >
                        <v-btn
                          v-if="$store.state.access[15][5]"
                          color="primary"

                          @click="$router.push('/client/revenue/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        class="d-sm-flex justify-end"
                        md="2"
                        xl="1"
                      >
                        <v-btn
                          v-if="$store.state.access[15][5]"
                          color="secondary"
                          outlined
                          @click="onReport"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="1"
                        class="d-sm-flex justify-center"
                      >
                        <v-icon
                          medium
                          class="icon-table"
                          @click="onShowHeadersDialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="mt-n5"
                      >
                        <div v-if="filter.set">
                          <div
                            v-for="(tab, index) in filterFields"
                            :key="'tab_f' + index"
                          >
                            <v-chip
                              v-for="(filter, index2) in tab.data.filter(a=>a.value ||a.value ===0 || a.from || a.to || a.max || a.min)"
                              :key="'data_f' + index2"
                              color="grey lighten-2"
                              class="ma-1"
                              close
                              @click:close="onClearFilterValue(filter)"
                            >
                              <span v-if="filter.type == 'date'">{{ filter.name }}: {{ format(filter.from) }}/{{ format(filter.to) }}</span>
                              <span v-else-if="filter.type == 'select' || filter.type == 'autocomplete'">{{ filter.name }}: {{ filter.select.filter(a=>a.value == filter.value)[0].text }}</span>
                              <span v-else>{{ filter.name }}: {{ filter.value }}</span>
                            </v-chip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <!--                    <v-row dense>-->
                    <!--                      <v-col cols="2">-->
                    <!--                        <v-checkbox-->
                    <!--                          v-model="show_deleted_point"-->
                    <!--                          label="Показать удалённые"-->
                    <!--                          @change="onChangeConf"-->
                    <!--                        />-->
                    <!--                      </v-col>-->
                    <!--                    </v-row>-->
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="100"
                  :nudge-bottom="12"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      v-bind="attrs"
                      color="primary"
                      text
                      v-on="on"
                      @click="sheetitem = item"
                    >
                      <v-icon
                        large
                        class="beg_triangle"
                      >
                        mdi-menu-open
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-item
                        v-if="!sheetitem.deleted"
                        @click="$router.push('/client/revenue/view?id=' + sheetitem.id)"
                      >
                        <v-list-item-content>
                          Открыть
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="!sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="$router.push('/client/revenue/change?id=' + sheetitem.id)"
                      >
                        <v-list-item-content>
                          Изменить
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="!sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="onDelete(sheetitem)"
                      >
                        <v-list-item-content>
                          Удалить
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="onRestore(sheetitem)"
                      >
                        <v-list-item-content>
                          Восстановить
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:item.client="{ item }">
                <span v-if="item && item.client">
                  {{ getClientName(item.client) }}
                </span>
              </template>
              <template v-slot:item.created="{ item }">
                <span v-if="item && item.created">
                  {{ formatDateTime(item.created) }}
                </span>
              </template>
              <template v-slot:item.approved="{ item }">
                <span v-if="item && item.approved">
                  {{ formatDateTime(item.approved) }}
                </span>
              </template>
              <template v-slot:item.creator="{ item }">
                <span v-if="item && item.creator">
                  {{ item.creator.name }} {{ item.creator.surname }}
                </span>
              </template>
              <template v-slot:item.changer="{ item }">
                <span v-if="item && item.changer">
                  {{ item.changer.name }} {{ item.changer.surname }}
                </span>
              </template>
              <template v-slot:item.nomenclature="{ item }">
                <span v-if="item && item.nomenclatures">
                  {{ getNomenclatureName(item.nomenclatures) }}
                </span>
              </template>
              <template v-slot:item.point="{ item }">
                <span v-if="item && item.point">
                  {{ getPointName(item.point) }}
                </span>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip
                  v-if="item"
                  :color="getStatusColor(item.status)"
                >
                  {{ item.status ? 'Проведён' : 'Не проведён' }}
                </v-chip>
              </template>
              <template v-slot:item.supplier="{ item }">
                <span v-if="item && item.supplier">
                  {{ getSupplierName(item.supplier) }}
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <!-- find dialog -->
      <v-dialog
        v-model="showFilterDialog"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-filter-outline"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <v-tabs
              v-model="tabIndex"
              v-resize="onResizeWindow"
              :vertical="verticalTabs"
            >
              <v-tab
                v-for="(tab, index) in filterFields"
                :key="index"
              >
                <div class="filter_row">
                  {{ tab.name }}
                  <v-btn
                    icon
                    @click="onSetFavouriteTab(tab.index)"
                  >
                    <v-icon
                      left
                      :class="[{'active': $store.state.user.tab_place == tab.index}]"
                    >
                      mdi-star
                    </v-icon>
                  </v-btn>
                </div>
              </v-tab>

              <v-tab-item
                v-for="(tab, index) in filterFields"
                :key="index"
              >
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="(field, index2) in tab.data"
                      :key="'i_'+index2"
                    >
                      <v-select
                        v-if="field.type=='select'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                      <div
                        v-else-if="field.type=='date'"
                        clearable
                        :label="field.name"
                        :items="field.select"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="field.date_select"
                              clearable
                              :label="field.name"
                              :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                              @change="onChangeFilterDateType($event, index , field)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.from"
                              :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                              :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                              type="date"
                              :max="maxDate"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-if="field.date_select == 'period'"
                              v-model="field.to"
                              label="До"
                              type="date"
                              :max="maxDate"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-text-field
                        v-else-if="field.type==='text'"
                        v-model="field.value"
                        :label="field.name"
                        :type="field.type"
                        @input="filter.changed = true"
                      />
                      <v-autocomplete
                        v-else-if="field.type==='autocomplete'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="showFilterDialog = false, onSetFilter()"
            >
              <span class="mx-10">Применить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="showFilterDialog = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <!-- dialog -->
      <v-dialog
        v-model="dialog.headers.show"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="headers.filter(a=>!a.show)"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.active_temp="{item}">
                <v-checkbox v-model="item.active_temp" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="dialog.headers.show = false, onSetHeaders()"
            >
              <span class="mx-10">Сохранить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="dialog.headers.show = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import moment from "moment"
// import $ from "jquery"
import { JustpayRevenueService } from "@/views/loyalty/shared/services/justpay-revenue-service"
// import { actionRevenue, stateRevenue } from "@/views/loyalty/models/justpay-revenue.model"
import { JustpayPointService } from "@/views/loyalty/shared/services/justpay-point-service"

export default {
  name: 'RevenueList',
  data: () => ({
    clients: [],
    dialog: {
      headers: {
        show: false
      }
    },
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    entity: 'client.revenue',
    filter: {
      set: false
    },
    filterFields: {
      common: {
        index: 0,
        name: "Основное",
        active: true,
        data: [
          {
            name: "Дата создания",
            data: "created",
            type: "date",
          },
          {
            name: "Дата проводки",
            data: "approved",
            type: "date",
          },
          {
            name: "Номер поставщика",
            data: "number",
            type: "text",
          },
          {
            name: "Клиент",
            data: "client",
            type: "autocomplete",
            select: []
          },
          {
            name: "Точка",
            data: "point",
            type: "autocomplete",
            select: []
          },
          // {
          //   name: "Тип задания",
          //   data: "action",
          //   type: "autocomplete",
          //   select: [...actionRevenue]
          // },
          {
            name: "Статус",
            data: "status",
            type: "select",
            select: [{ text: 'Не проведён', value: false }, { text: 'Проведён', value: true }]
          },
          // {
          //   name: "Слип",
          //   data: "slip",
          //   type: "text",
          // },
          {
            name: "Код товара",
            data: "nomenclature",
            type: "autocomplete",
            select: []
          },

        ]
      }
    },
    form: {},
    headers: [
      {
        text: 'Действия',
        value: 'actions',
        show: true
      },
      {
        text: 'Дата создания',
        value: 'created',
        active: true,
        active_temp: true
      },
      {
        text: 'Дата проводки',
        value: 'approved',
        active: true,
        active_temp: true
      },
      {
        text: 'Номер',
        value: 'number',
        active: true,
        active_temp: true
      },
      {
        text: 'Клиент',
        value: 'client',
        active: true,
        active_temp: true
      },
      {
        text: 'Кто создал',
        value: 'creator',
        active: true,
        active_temp: true
      },
      {
        text: 'Кто изменил',
        value: 'changer',
        active: true,
        active_temp: true
      },
      {
        text: 'Поставщик',
        value: 'supplier',
        active: true,
        active_temp: true
      },
      {
        text: 'Наименование товара',
        value: 'nomenclature',
        active: true,
        active_temp: false
      },
      {
        text: 'Закупочная цена',
        value: 'purchasePrice',
        active: true,
        active_temp: false
      },
      {
        text: 'Количество',
        value: 'quantity',
        active: true,
        active_temp: false
      },
      {
        text: 'Точка',
        value: 'point',
        active: true,
        active_temp: false
      },
      {
        text: 'Статус',
        value: 'status',
        active: true,
        active_temp: true
      },
    ],
    items: [],
    // justpayPointService: null,
    justpayRevenueService: null,
    loading: false,
    nomenclatures: [],
    points: [],
    sheetitem: {},
    showFilterDialog: false,
    showHeaderDialog: false,
    suppliers: [],
    tabIndex: 0,
    table_options: {},
    total: 0,

    verticalTabs: true,
  }),
  computed: {
    maxDate: function () {
      return moment().format('YYYY-MM-DD')
    },
  },
  watch: {
    table_options: {
      async handler () {
        console.log(this.table_options)
        this.$router.push({
          query: {
            page: this.table_options.page,
            limit: this.table_options.itemsPerPage
          }
        })
        await this.loadAsync()
      },
      deep: true,
    },
  },
  beforeMount () {
    // this.justpayPointService = new JustpayPointService()
    this.justpayRevenueService = new JustpayRevenueService()
    this.setDefaultHeaders()
  },
  async mounted () {
    await this.loadAsync()
  },
  methods: {
    format: function (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    formatDateTime: function (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    formatInputDate: function (_date) {
      const date = new Date(_date)
      let dd = date.getDate()
      if (dd < 10) dd = '0' + dd

      let mm = date.getMonth() + 1
      if (mm < 10) mm = '0' + mm

      let yyyy = date.getFullYear()
      if (yyyy < 10) yyyy = '0' + yyyy

      return yyyy + '-' + mm + '-' + dd
    },
    getClientName (clientId) {
      return this.clients.find(client => client.value === clientId).text
    },
    getNomenclatureName (products) {
      // console.log('nomenclatureId', nomenclatureId)
      // if (!nomenclatureId) return []
      // return this.nomenclatures.length>0 ? this.nomenclatures.find(nomenclature => nomenclature.value === nomenclatureId).text : []
      return products.reduce((acc, item) => acc + `${item.name} - ${item.quantity} шт; `, '')
    },
    getPointName (pointId) {
      return this.points.find(point => point.value === pointId).text
    },
    getStatusColor: function (status) {
      return status ? 'green' : 'yellow'
    },
    getSupplierName (supplierId) {
      const found = this.suppliers.find(supplier => supplier.value === supplierId)
      return found ? found.text : ''
    },
    async loadAsync () {
      const request = JSON.parse(JSON.stringify(this.form))
      console.log('request', request)
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filterFields))
        delete request.data.set
        delete request.data.changed
      }
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
      request.page = page
      request.limit = itemsPerPage
      // request.all = this.show_deleted_point
      const response = await this.justpayRevenueService.getRevenues(request)
      console.log('response', response)

      if (!response.error) {
        this.items = response.data
        this.total = response.count
        this.clients = response.clients
        this.nomenclatures = response.nomenclatures
        this.points = response.points
        this.suppliers = response.suppliers
      }
      this.loading = false
    },
    async onChangeConf () {
      await this.loadAsync()
    },
    onChangeFilterDateType (value, tab, field) {
      this.filter.changed = true
      console.log('changeFilterDateType', value, tab, field)
      if (tab && field && value) {
        if (value !== 'period' && value !== 'date') {
          let date = 0
          if (value == 'today') {
            date = new Date()
          } else if (value == 'yesterday') {
            date = new Date().setDate(new Date().getDate() - 1)
          } else if (value == 'tomorrow') {
            date = new Date().setDate(new Date().getDate() + 1)
          }
          const formated_date = this.formatInputDate(date)
          field.from = formated_date
          field.to = formated_date
        }
        if (value == 'date') {
          field.to = ''
        }
      }
    },
    onClearFilterValue (field) {
      field.value = ''
      field.from = ''
      field.to = ''
      field.date_select = ''
      field.min = ''
      field.max = ''
      this.filter.changed = true
      this.onSetFilter()
    },
    async onDelete (item) {
      if (confirm('Вы уверены?')) {
        item.deleted = true
        await this.justpayRevenueService.changeRevenue(item)
        this.loading = false
        await this.loadAsync()
      }
    },
    async onLoad () {
      await this.loadAsync()
    },
    onReport () {
      const request = JSON.parse(JSON.stringify(this.form))
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filter_fields))
        delete request.data.set
        delete request.data.changed
      }
      request.headers = this.headers.filter(a => a.active == true).map(a => a.value)
      const form = $('<form>', {
        target: '_blank',
        action: '/api/revenue/export?token=' + localStorage.getItem("token"),
        method: 'post',
      })
      form.append(
          $('<input>', {
            type: 'hidden',
            value: JSON.stringify(request),
            name: 'form',
          })
      )
      form.appendTo('body').submit()
    },
    onResizeWindow () {
      this.verticalTabs = window.innerWidth > 600
    },
    onSetFavouriteTab (index) {
      this.axios.post('/api/user/favourite_tab', { value: index, type: 'tab_point' })
          .then(result => {
            if (!result.data.error) {
              this.$store.commit('SET_FAVOURITE_TAB', { value: index, type: 'tab_point' })
            }
          })
          .catch(e => {
          })
    },
    async onRestore (item) {
      if (confirm('Вы уверены?')) {
        item.deleted = false
        await this.justpayRevenueService.changeRevenue(item)
        this.loading = false
        await this.loadAsync()
      }
    },
    async onSetFilter () {
      if (this.filter.changed) this.filter.set = true
      this.filter.changed = false
      await this.loadAsync()
      localStorage.setItem(this.entity, JSON.stringify(this.filter_fields))
    },
    onSetHeaders () {
      for (const x in this.headers) {
        this.headers[x].active = this.headers[x].active_temp
      }
      this.$axios.post('/api/user/headers', {
        entity: 'revenue',
        headers: this.headers.filter(a => a.active).map(a => a.value)
      })
          .catch(e => {
            console.log(e)
          })
    },
    async onShowFilterDialog () {
      this.showFilterDialog = true
      this.filterFields.common.data.forEach(f => {
        if (f.data === 'point') {
          f.select = this.points
        }
        if (f.data === 'client') {
          f.select = this.clients
        }
        if (f.data === 'nomenclature') {
          f.select = this.nomenclatures
        }
        if (f.data === 'supplier') {
          f.select = this.suppliers
        }
      })
    },
    onShowHeadersDialog () {
      for (const x in this.headers) {
        this.headers[x].active_temp = this.headers[x].active
      }
      this.dialog.headers.show = true
    },
    setDefaultHeaders () {
      if (!this.$store.state.user.revenueHeaders || this.$store.state.user.revenueHeaders.length === 0) return
      this.headers = this.headers.map(header => {
        header.active = this.$store.state.user.revenueHeaders.indexOf(header.value) > -1
      return header
})
    },
  }
}
</script>

<style scoped>

</style>
